import { UserAction, UserState } from "./types";

export const updateUser = (params: Partial<UserState>): UserAction => ({ type: "USER_UPDATE", params })

export const clearUser = (): UserAction => ({ type: 'USER_CLEAR' })